import { TeaBlocksError } from './../../TeaBlocksError';
import { ReturnBlock } from "../ReturnBlock";

/**
 * Takes in the shape name (display name), checks if the name exists, and returns the internal name of the shape.
 */
export class GetShapeBlock extends ReturnBlock {
    shapeName: string;

    /**
     * Constructor
     * @param shapeName the name of the shape being retrieved
     */
    constructor(id: string, shapeName: string) {
        super(id)
        this.shapeName = shapeName;
    }

    /**
     * Retrieves the internal shape name. Throws error if it does not exist.
     * @param varEnv variable environment
     */
    evalBlock(varEnv: Map<string, any>): string {
        let internalName = '$' + this.shapeName;
        if (varEnv.has(internalName)) return internalName;
        throw new TeaBlocksError(`Shape ${this.shapeName} does not exist!`, this.id);
    }

}